
import Scanner from './Scanner'
import SymbolTable from './SymbolTable'
import ProgramCode from './ProgramCode'
import HintHelper from './HintHelper'
import ParseProcess from './Components/ParseProcess.js'
import ParseCallable from './Components/ParseCallable.js'

function Parser (options) {
    function emptyCb () {

    }

    this.callbacks = {
        error: options['errorCb'] === undefined ? emptyCb : options.errorCb,
        procName: options['procNameCb'] === undefined ? emptyCb : options.procNameCb,
        hint: options['hintCb'] === undefined ? emptyCb : options.hintCb,
        autocomplete: options['autocompleteCb'] === undefined ? emptyCb : options.autocompleteCb,
        outline: options['outlineCb'] === undefined ? emptyCb : options.outlineCb,
        inspectionSuccess: options['inspectionSuccessCb'] === undefined ? emptyCb : options.inspectionSuccessCb,
        inspectionError: options['inspectionErrorCb'] === undefined ? emptyCb : options.inspectionErrorCb
    }
    if (!options.config) {
        throw new Error('Parser: falta configuración del lenguaje.')
    }
    this.contexts = []
    this.inspections = {}
    if (options['inspections'] !== undefined) {
        this.inspections = options['inspections']
    }
    this.config = options.config.getTokens()
    this.caseSensitive = options.config.isCaseSensitive()
    this.keywords = options.config.keywords()
    this.compile = true
    this.hintInfo = {
        word: '',
        line: 0,
        column: 0
    }
    this.currentProcName = '_'
    this.hintHelper = null
    this.isAutocomplete = false
    this.autocompleteLine = 0
    this.shouldParse = true
    this.outline = {}
    this.stable = null
    this.pcode = null
    this.scanner = null
    this.externalFunc = options.externalFunc ? options.externalFunc : {}
}

Parser.prototype = {
    lint (code) {
        this.compile = false
        this.shouldParse = true
        this.outline = {}
        this.hintHelper = null
        this.begin(code)
    },
    hint (word, line, column, code) {
        this.compile = false
        this.shouldParse = true
        this.outline = {}
        this.hintHelper = new HintHelper(word, line, column, this.callbacks.hint)
        this.begin(code)
    },
    autocomplete (line, code) {
        this.isAutocomplete = true
        this.autocompleteLine = line
        this.shouldParse = true
        this.outline = {}
        this.hintHelper = null
        this.begin(code)
    },
    parse (code) {
        let program
        this.compile = true
        this.shouldParse = true
        this.outline = {}
        program = this.begin(code)
        if (program !== false) {
            return program
        }
        return false
    },
    scannerError (text, line, column) {
        console.log('scannerError')
        this.callbacks.error(
            'No se reconoce el símbolo.',
            line,
            column,
            line,
            column + (text + '').length)
        this.shouldParse = false
    },
    error (token, message) {
        this.callbacks.error(
            message,
            token.line,
            token.column,
            token.line,
            token.column + (token.lexema + '').length)
        this.compile = false
    },
    isKeyword (str) {
        for (let keyword of this.keywords) {
            if (keyword.toLowerCase() === str.toLowerCase()) {
                return true
            }
        }
        return false
    },
    expect (token, tokenWhere) {
        if (this.scanner.next().code !== token.code) {
            let name = token.keywords !== undefined ? token.keywords.join(', ') : token.name
            this.error(tokenWhere || this.scanner.next(), 'Se esperaba ' + name + ' y se encontro ' + this.scanner.next().lexema + '.')
            return false
        }
        return this.scanner.consume()
    },
    pushContext (context) {
        this.contexts.push({
            pcode: this.pcode,
            stable: this.stable,
            scanner: this.scanner
        })
        if (context.pcode) {
            this.pcode = context.pcode
        }
        if (context.stable) {
            this.stable = context.stable
        }
        if (context.scanner) {
            this.scanner = context.scanner
        }
    },
    popContext () {
        let context = {
            pcode: this.pcode,
            stable: this.stable,
            scanner: this.scanner
        }
        let prev = this.contexts.pop()
        this.pcode = prev.pcode
        this.stable = prev.stable
        this.scanner = prev.scanner
        return context
    },
    begin (code) {
        // Base parser objects
        this.stable = new SymbolTable()

        if (this.compile) {
            this.pcode = new ProgramCode()
        }

        // Parse all symbols
        this.scanner = Scanner(this.config, this.caseSensitive, this.scannerError.bind(this))
        this.scanner.analyze(code)

        // Init Hint
        if (this.hintHelper) {
            this.hintHelper.setScanner(this.scanner)
        }

        // Main entry
        function parseProgram () {
            let startJump
            let parseCallable = new ParseCallable(this)
            let parseProcess = new ParseProcess(this)
            if (this.compile) {
                startJump = this.pcode.jump(0, this.scanner.next())
            }

            parseCallable.parse()

            if (this.compile) {
                startJump.op1 = this.pcode.instructionCount() + 1
            }

            parseProcess.parse()
        }

        if (this.shouldParse) {
            this.stable.enterBlock()
            parseProgram.bind(this).call()
            this.stable.exitBlock()

            if (this.compile) {
                this.callbacks.outline(this.outline)
                return this.pcode
            }
        }

        return false
    }
}

export default Parser



// WEBPACK FOOTER //
// ./src/Core/Parser/Parser.js